import { Turbo, cable } from "@hotwired/turbo-rails"
import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import 'popper.js';
import 'bootstrap';
import 'emoji-picker-element';
import initYoutubeParser from './youtube';
import ScrollButtons from './scroll_buttons';
import '@github/markdown-toolbar-element'
import Lightbox from "stimulus-lightbox"
import ContentLoader from "stimulus-content-loader"
import './prefetch'

const application = Application.start()
application.register("lightbox", Lightbox)
application.register("content-loader", ContentLoader)
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))

global.jquery = global.jQuery = global.$ = require('jquery');

initYoutubeParser();

$(function () {
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
  $('.emoji-button').popover({
      content: $('#emoji-tooltip').html(),
      html: true
    }
  )
})

document.addEventListener('turbo:load', () => {
  const container = document.getElementById('games-container');

  if (!container) {
    return;
  }

  ScrollButtons.init({
    container,
    backButton: document.getElementById('game-slider-back'),
    forwardButton: document.getElementById('game-slider-forward'),
  });
});

document.addEventListener('turbo:load', (event)=> {
  ym(34298535, 'hit', event.detail.url)
})
